// Generated by CoffeeScript 2.7.0
var DropdownSelect;

export default DropdownSelect = Vue.extend({
  props: {
    optionGroups: {
      type: Array,
      default: function() {
        return [];
      }
    },
    initValue: [Object, String, Number],
    customClass: String,
    placeholder: {
      type: String,
      default: '请选择'
    },
    optionGroupsFixed: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      currentOption: null,
      currentGroup: null,
      dropdownOpen: false
    };
  },
  template: `<div class="dropdown-select" :class='[{ active: dropdownOpen }, customClass]'>
  <div class="display-container" @click='toggleDropdown'>
    <div class="placeholder" v-if='_.isBlank(currentOption)'>{{ placeholder }}</div>
    <div class="display-value" v-else>
      <slot name='value-template' :option='currentOption'></slot>
    </div>
    <i class="slp-caret-v expander"></i>
  </div>
  <div class="select-option-groups" :class="{ 'expanded': optionGroupsFixed }" ref='optionGroupRef'>
    <div class='group-item'
         v-for='(group, index) in optionGroups'
        :key='index'>
      <div class='select-option-item'
           :class='{ active: currentOption == option}'
           v-for='option in group.options'
           @click='select(option, group)'>
        <slot name='option-template'
              :option='option'
              :initValue='currentOption'></slot>
      </div>
    </div>
  </div>
</div>`,
  watch: {
    'initValue': function() {
      return this.currentOption = this.initValue;
    }
  },
  created: function() {
    return this.currentOption = this.initValue;
  },
  methods: {
    select: function(option, group) {
      this.currentOption = option;
      this.currentGroup = group;
      return this.$emit('change', option, group);
    },
    toggleDropdown: function() {
      this.dropdownOpen = !this.dropdownOpen;
      if (this.dropdownOpen) {
        this.$nextTick(function() {
          var ref;
          if (this.optionGroupsFixed) {
            return this.calculatePosition();
          } else {
            return (ref = this.$refs.optionGroupRef) != null ? ref.style.top = `-${DomMaster.find('.select-option-item.active', this.$el).node.offsetTop}px` : void 0;
          }
        });
        return Skylark.Helpers.App.capturedBackdrop(() => {
          return this.dropdownOpen = false;
        }, void 0);
      }
    },
    calculatePosition: function() {
      var active_option_offsetTop, buffer_bottom, buffer_top, option_group_padding, option_group_rect, option_group_ref, scrollable_container_client_rect;
      this.resetPosition();
      if (!this.dropdownOpen) {
        return;
      }
      option_group_ref = this.$refs.optionGroupRef;
      scrollable_container_client_rect = document.body.getBoundingClientRect();
      option_group_rect = option_group_ref.getBoundingClientRect();
      active_option_offsetTop = DomMaster.find('.select-option-item.active', this.$el).node.offsetTop;
      option_group_padding = 10;
      buffer_top = 70;
      buffer_bottom = 80;
      if (option_group_ref.style.position !== 'fixed') {
        _.extend(option_group_ref.style, {
          position: 'fixed',
          minWidth: 0,
          left: `${option_group_rect.left}px`,
          width: `${option_group_rect.width}px`
        });
      }
      if (scrollable_container_client_rect.bottom - buffer_bottom < option_group_rect.bottom - active_option_offsetTop + option_group_padding) {
        option_group_ref.style.top = "auto";
        return option_group_ref.style.bottom = `${buffer_bottom}px`;
      } else if (buffer_top > option_group_rect.top - active_option_offsetTop) {
        option_group_ref.style.top = `${buffer_top}px`;
        return option_group_ref.style.bottom = "auto";
      } else {
        option_group_ref.style.top = `${option_group_rect.top - active_option_offsetTop + option_group_padding}px`;
        return option_group_ref.style.bottom = "auto";
      }
    },
    resetPosition: function() {
      return this.$refs.optionGroupRef.setAttribute('style', null);
    }
  }
});
